/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEquityContract} from '../api'

 export const useQueryGetEquityContract = createReactQueryHook('getEquityContract', getEquityContract)
